import type { Prototype } from "../prototype-types";

export const nickHowlandPrototypes: Prototype[] = [
  {
    id: "nh-progressive-modal",
    name: "Progressive Modal",
    path: "/nh/progressive-modal",
    description:
      "Slate Progressive Modal (WIP): multi-step modal with header step navigation, progress bar footer, and desktop and mobile layouts. Design Platform Spec pattern with anatomy, layout, a11y and motion tabs.",
    owner: "Nick Howland",
    createdAt: "2026-10-28",
    lastUpdated: "2026-10-28",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/nh-progressive-modal.png",
    creationTool: "claude-code",
  },
  {
    id: "quantity-picker",
    name: "Quantity Picker",
    path: "/nh/quantity-picker",
    description:
      "Quantity Picker component for cart and order-form contexts. Design Platform Spec pattern with anatomy, layout, a11y, motion tabs, and two page mockups.",
    owner: "Nick Howland",
    createdAt: "2026-05-04",
    lastUpdated: "2026-05-13",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/2e0fd5d7d02d44084f8a3186517a12626c57d4d8305e6d67218ba83fa5703176.png",
    creationTool: "claude-code",
  },
  {
    id: "file-upload",
    name: "File Upload",
    path: "/nh/file-upload",
    description:
      "Three-concept file upload control with drag-and-drop, click-to-browse, progress feedback, and inline file rows. Demonstrates the Design Platform Spec pattern with anatomy, layout, a11y, and motion tabs.",
    owner: "Nick Howland",
    createdAt: "2026-04-15",
    lastUpdated: "2026-05-08",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/580c93eba0b132e705b37281c9f320ed1bdfa66c229b7d4215fb7d515bbafd39.png",
    creationTool: "claude-code",
  },
  {
    id: "nh-nested-radio-block-iterations",
    name: "Nested Radio Block Iterations",
    path: "/nh/nested-radio-block-iterations",
    description:
      "Interactive prototype of the 'How did you hear about Faire?' radio block list, exploring three layout treatments for a new expandable Google AI option that reveals nested sub-choices when selected.",
    owner: "Nick Howland",
    createdAt: "2026-07-28",
    lastUpdated: "2026-07-28",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.faire.com/fastly/82cf0bcfecfb4f183013a3219d41754551be520ac2d6bce1c70c99e73f40c540.png",
    creationTool: "claude-code",
  },
  {
    id: "nick-password-strength-meter",
    name: "Password Strength Meter",
    path: "/nh/password-strength-meter",
    description:
      "Password strength feedback meter as an optional enhancement to the Slate PasswordInput component. Segmented 4-part progress bar with coaching text, OWASP-aligned scoring, and monochrome/color variants.",
    owner: "Nick Howland",
    createdAt: "2026-06-23",
    lastUpdated: "2026-08-04",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.faire.com/fastly/7aeb6955be039540c68a9f7906c46f646fa388d06b659386f30bfe5f82391d3d.png",
    creationTool: "claude-code",
  },
  {
    id: "nh-form",
    name: "Form",
    path: "/nh/form",
    description:
      "Slate Form component: visual layer on top of the existing Controlled Forms (Formik+Yup) framework.",
    owner: "Nick Howland",
    createdAt: "2026-07-30",
    lastUpdated: "2026-08-07",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/f4e86716351dd8be6a9ef2c20cdb7eb6712f11614b1d0dc2533fb2a2905430fb.png",
    creationTool: "claude-code",
  },
  {
    id: "nh-collection-multiselect",
    name: "Collection Page Multi-Select",
    path: "/nh/collection-multiselect",
    description:
      "Fall scents collection page with a Select toggle for bulk multi-select actions on product tiles",
    owner: "Nick Howland",
    createdAt: "2026-08-18",
    lastUpdated: "2026-08-18",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/nh-collection-multiselect.png",
    creationTool: "claude-code",
  },
  {
    id: "nh-modal-width-audit",
    name: "Modal Width Audit",
    path: "/nh/modal-width-audit",
    description:
      "Mocks up brand-portal legacy modals wider than Slate&#39;s largest Base Modal token (648px) rendered at their current custom width today, and remapped onto Slate Base&#x2F;Canvas Modal size variants, to assess which fit existing tokens vs need a new width.",
    owner: "Nick Howland",
    createdAt: "2026-08-18",
    lastUpdated: "2026-08-18",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/nh-modal-width-audit.png",
    creationTool: "claude-code",
  },
  {
    id: "nh-marketing-modal-title-size-audit",
    name: "Marketing Modal Title Size Audit",
    path: "/nh/marketing-modal-title-size-audit",
    description:
      "Compares Display S (30px) vs Page Heading (22px) for Marketing Modal titles against real production title strings, at iPhone 17 and iPhone 17e widths, with an English&#x2F;German toggle.",
    owner: "Nick Howland",
    createdAt: "2026-08-25",
    lastUpdated: "2026-08-25",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/nh-marketing-modal-title-size-audit.png",
    creationTool: "claude-code",
  },
];
